<template>
  <v-row>
    <v-col
      cols="4"
      style="height: calc(100vh - 300px); overflow: scroll"
      class="py-0"
    >
      <v-card style="position: sticky; top: 0px" flat>
        <suppliers-search
          :destination-id="destinationId"
          @supplier-edit="onSupplierEdit"
        ></suppliers-search>
      </v-card>
    </v-col>

    <v-col cols="8" style="height: calc(100vh - 300px); overflow: scroll">
      <template-builder-day-by-day-item
        v-for="day in duration"
        :key="day"
        :day="day"
        :duration="duration"
        :template-items="items"
        @change="onDayChange"
        @delete="onItemDelete"
        @custom-price="onItemCustomPrice"
      ></template-builder-day-by-day-item>
      <template-builder-item-pricing-dialog
        v-model="editedItem"
        :show="showPricingDialog"
        @close="showPricingDialog = false"
        @save="onItemSave"
      ></template-builder-item-pricing-dialog>
      <div v-if="debug">
        <code> {{ items }}</code>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import SuppliersSearch from "./SuppliersSearch";
import TemplateBuilderDayByDayItem from "./TemplateBuilderDayByDayItem";
import TemplateBuilderItemPricingDialog from "./TemplateBuilderItemPricingDialog";
export default {
  name: "template-builder-day-by-day",

  props: {
    duration: {
      type: Number,
      default: () => 0,
    },
    destinationId: {
      type: String,
      default: () => "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    SuppliersSearch,
    TemplateBuilderDayByDayItem,
    TemplateBuilderItemPricingDialog,
  },

  data() {
    return {
      debug: false,
      editedItem: null,
      showPricingDialog: false,
    };
  },

  methods: {
    onSupplierEdit(payload) {
      this.$emit("supplier-edit", payload);
    },
    onItemSave(data) {
      //console.log("saving item", data);
      this.showPricingDialog = false;
      this.$emit("update-item", { ...this.editedItem });
    },
    onDayChange(payload) {
      if (payload.added) {
        const el = { ...payload.added.element, day: payload.day };
        const existing = this.items.find((item) => item.uid == el.uid);
        if (existing) {
          //console.log("updating item", payload.day, el);
          const maxDuration = this.itemMaxDuration(el.serviceType, el.day);
          if (el.duration > maxDuration) {
            el.duration = maxDuration;
          }
          if (el.extras) {
            for (const extra of el.extras) {
              extra.day = payload.day;
              if (extra.duration > maxDuration) {
                extra.duration = maxDuration;
              }
            }
          }
          this.$emit("update-item", { ...el });
        } else {
          if (el.extras) {
            const maxDuration = this.itemMaxDuration(el.serviceType, el.day);
            for (const extra of el.extras) {
              extra.day = payload.day;
              if (extra.duration > maxDuration) {
                extra.duration = maxDuration;
              }
            }
          }
          this.$emit("add-item", { ...el });
        }
      }
      //update order
      let order = Number(payload.day) * 100;
      let c = 1;
      for (const updateItemUid of payload.order) {
        const updateItem = this.items.find((item) => item.uid == updateItemUid);
        if (updateItem) {
          updateItem.order = order + c;
          c++;
        }
      }
    },
    onItemDelete(payload) {
      this.$emit("remove-item", payload);
    },
    onItemCustomPrice(payload) {
      this.editedItem = { ...payload };
      this.showPricingDialog = true;
    },
    itemMaxDuration(type, day) {
      let maxDuration = this.duration - day;
      if (type != "ACCOMMODATION") {
        maxDuration++;
      }
      if (maxDuration == 0) {
        maxDuration = 1;
      }
      return maxDuration;
    },
  },
};
</script>

<style>
.fixed {
  position: fixed;
  top: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/TemplateBuilderDayByDay.vue